/**
 * Layout condiviso chatbot: mobile, desktop, totem.
 * Richiede #chatbot-embed-settings (JSON) e [data-chatbot-layout] sul contenitore.
 */
(function () {
  'use strict';

  var BREAKPOINT = 750;
  var settingsCache = null;

  function getSettings() {
    if (settingsCache) return settingsCache;
    var node = document.getElementById('chatbot-embed-settings');
    if (!node) return null;
    try {
      settingsCache = JSON.parse(node.textContent);
      return settingsCache;
    } catch (e) {
      return null;
    }
  }

  function isTotemQuery() {
    return new URLSearchParams(window.location.search).has('chatbot_totem');
  }

  function isTotemLikeScreen() {
    if (isTotemQuery()) return true;
    /* Kiosk / totem: schermi grandi in verticale, non smartphone */
    if (window.matchMedia('(min-height: 1100px) and (min-width: 720px) and (max-aspect-ratio: 10/16)').matches) {
      return true;
    }
    if (window.matchMedia('(min-height: 1400px) and (max-aspect-ratio: 3/4)').matches) {
      return true;
    }
    return false;
  }

  function getLayoutMode() {
    if (isTotemLikeScreen()) return 'totem';
    if (window.matchMedia('(min-width: ' + BREAKPOINT + 'px)').matches) return 'desktop';
    return 'mobile';
  }

  function getOrientationForMode(mode) {
    return mode === 'desktop' ? 'horizontal' : 'vertical';
  }

  function getSrcForOrientation(orientation) {
    var settings = getSettings();
    if (!settings) return '';
    return orientation === 'horizontal' ? settings.horizontal : settings.vertical;
  }

  function applyLayout(root) {
    if (!root) return getLayoutMode();
    var mode = getLayoutMode();
    var orientation = getOrientationForMode(mode);
    var iframe = root.querySelector('[data-chatbot-iframe]');

    root.classList.remove(
      'chatbot-layout--mobile',
      'chatbot-layout--desktop',
      'chatbot-layout--totem'
    );
    root.classList.add('chatbot-layout--' + mode);
    root.dataset.chatbotLayoutMode = mode;

    if (iframe) {
      iframe.dataset.chatbotOrientation = orientation;
      var shouldLoad = root.dataset.chatbotIframeActive === 'true';
      var currentSrc = iframe.getAttribute('src') || '';
      var nextSrc = getSrcForOrientation(orientation);

      if (shouldLoad && nextSrc && currentSrc !== nextSrc) {
        iframe.setAttribute('src', nextSrc);
      }
    }

    var fullscreenBtn = root.querySelector('[data-chatbot-fullscreen]');
    if (fullscreenBtn) {
      fullscreenBtn.hidden = false;
    }

    return mode;
  }

  function loadIframe(root) {
    if (!root) return;
    root.dataset.chatbotIframeActive = 'true';
    var iframe = root.querySelector('[data-chatbot-iframe]');
    if (!iframe) return;
    var orientation = getOrientationForMode(getLayoutMode());
    var src = getSrcForOrientation(orientation);
    if (src) iframe.setAttribute('src', src);
  }

  function unloadIframe(root) {
    if (!root) return;
    root.dataset.chatbotIframeActive = 'false';
    var iframe = root.querySelector('[data-chatbot-iframe]');
    if (!iframe) return;
    iframe.removeAttribute('src');
    iframe.removeAttribute('data-chatbot-orientation');
  }

  function getFullscreenTarget(root) {
    return root.querySelector('[data-chatbot-fullscreen-target]') || root;
  }

  function isFullscreen(root) {
    var target = getFullscreenTarget(root);
    var active = document.fullscreenElement || document.webkitFullscreenElement;
    return active === target;
  }

  function exitFullscreen() {
    var exit = document.exitFullscreen || document.webkitExitFullscreen;
    if (exit) exit.call(document);
  }

  function toggleFullscreen(root) {
    var target = getFullscreenTarget(root);
    if (isFullscreen(root)) {
      exitFullscreen();
      return;
    }
    applyLayout(root);
    if (getLayoutMode() === 'desktop') {
      var iframe = root.querySelector('[data-chatbot-iframe]');
      var src = getSrcForOrientation('horizontal');
      if (iframe && root.dataset.chatbotIframeActive === 'true' && src) {
        iframe.setAttribute('src', src);
      }
    }
    var request = target.requestFullscreen || target.webkitRequestFullscreen;
    if (request) request.call(target);
  }

  function updateFullscreenButton(root) {
    var btn = root.querySelector('[data-chatbot-fullscreen]');
    if (!btn) return;
    var isFs = isFullscreen(root);
    var expand = btn.querySelector('[data-chatbot-icon-expand]');
    var exitIcon = btn.querySelector('[data-chatbot-icon-exit]');
    if (expand) expand.hidden = isFs;
    if (exitIcon) exitIcon.hidden = !isFs;
    btn.setAttribute('aria-label', isFs ? 'Esci da schermo intero' : 'Apri a schermo intero');
  }

  function bindLayout(root, options) {
    options = options || {};
    if (!root || root.dataset.chatbotLayoutBound === 'true') return;
    root.dataset.chatbotLayoutBound = 'true';

    var onLayoutChange = function () {
      applyLayout(root);
      if (options.onLayoutChange) options.onLayoutChange(getLayoutMode());
    };

    onLayoutChange();

    window.matchMedia('(min-width: ' + BREAKPOINT + 'px)').addEventListener('change', onLayoutChange);
    window.matchMedia('(orientation: portrait)').addEventListener('change', onLayoutChange);
    window.matchMedia('(max-aspect-ratio: 3/4)').addEventListener('change', onLayoutChange);

    var fullscreenBtn = root.querySelector('[data-chatbot-fullscreen]');
    if (fullscreenBtn) {
      fullscreenBtn.addEventListener('click', function () {
        toggleFullscreen(root);
      });
      document.addEventListener('fullscreenchange', function () {
        updateFullscreenButton(root);
      });
      document.addEventListener('webkitfullscreenchange', function () {
        updateFullscreenButton(root);
      });
      updateFullscreenButton(root);
    }

    if (options.watchResize) {
      window.addEventListener('resize', onLayoutChange, { passive: true });
    }
  }

  window.ChatbotLayout = {
    BREAKPOINT: BREAKPOINT,
    getSettings: getSettings,
    getLayoutMode: getLayoutMode,
    isTotemLikeScreen: isTotemLikeScreen,
    applyLayout: applyLayout,
    loadIframe: loadIframe,
    unloadIframe: unloadIframe,
    bindLayout: bindLayout,
    isFullscreen: isFullscreen,
    exitFullscreen: exitFullscreen,
    toggleFullscreen: toggleFullscreen,
    updateFullscreenButton: updateFullscreenButton,
    getFullscreenTarget: getFullscreenTarget
  };
})();
